import IImageRepository from 'domain/interfaces/repositories/IImageRepository'

export const uploadImageCommand = (repository: IImageRepository, file: FormData) => {
  return repository.uploadImage(file)
}
